﻿/**
 * ManufactureProductSection
 *
 * Used Products tab for the manufacturer profile.
 * This lists products linked to the manufacturer as a company.
 */
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Stack,
  Typography,
  Avatar
} from "@mui/material";
import {
  MoreVert as MoreIcon,
  Inventory2 as InventoryIcon,
  Build as BuildIcon
} from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_COMPANIES_PRODUCTS, SAVE_COMPANY_PRODUCT } from "../../constant/Apipath";
import Loader from "../../common/Loader";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import AddProductModal from "../common/AddProductModal";
import Emptydata from "../common/Emptydata";
import { English } from "../../constant/EnglishFallback";
import { setShowReport } from "../../redux/actions/actions";
import Pages from "../../constant/ReportModel";

const USED_PRODUCTS_TAB_LABEL = "Used Products";

function ManufactureProductSection({
  id,
  scrollId,
  manufactureDetails,
  allowPublicProductSubmission = true,
  color = ""
}) {
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const LanguageData = multiLanguageData?.Companies || {};
  const {
    TEXT_ADD_PRODUCT = English.Companies.TEXT_ADD_PRODUCT,
    TEXT_SEARCH_COMPANY_PRODUCTS = English.Companies.TEXT_SEARCH_COMPANY_PRODUCTS,
    BUTTON_REPORT = English.Companies.BUTTON_REPORT,
    TEXT_NO_DATA_INFO_SUBTEXT = English.Companies.TEXT_NO_DATA_INFO_SUBTEXT,
    TEXT_NO_INFO_COMPANY = English.Companies.TEXT_NO_INFO_COMPANY,
    TEXT_NO_RESULTS_FOUND = English.Companies.TEXT_NO_RESULTS_FOUND,
    TEXT_ADD_PRODUCT_TO_COMPANY = English.Companies.TEXT_ADD_PRODUCT_TO_COMPANY
  } = LanguageData || {};
  const { TEXT_ADD_PRODUCT_TO_MANUFACTURER = English.Manufacturers.TEXT_ADD_PRODUCT_TO_MANUFACTURER } =
    multiLanguageData?.Manufacturers || {};

  const debounceTimeout = useRef(null);
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProductData(searchTerm, 1, "firstTimeApiCall");
    setIsLoading(false);
  };

  const getProductData = async (term, pageNum, firstTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNum,
        NrOfRecPerPage: 20,
        FullSearch: term ?? "",
        SearchList: [{ companyId: id }],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{}],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };

      const res = await Postrequestcall(FETCH_COMPANIES_PRODUCTS, obj, loginData?.accessToken);
      if (res.status === 200) {
        const resData =
          res?.data?.data?.sort((a, b) => a?.productName?.localeCompare(b?.productName)) ?? [];

        const groupedData = resData.reduce((acc, item) => {
          const key =
            item?.manufacturerId === 0 || !item?.manufacturerName?.trim()
              ? "No Manufacturer"
              : item?.manufacturerName;
          if (!acc[key]) {
            acc[key] = {
              manufacturerId: item?.manufacturerId,
              manufacturerName:
                item?.manufacturerId === 0 || !item?.manufacturerName?.trim()
                  ? "No Manufacturer"
                  : item?.manufacturerName,
              items: []
            };
          }
          acc[key].items.push(item);
          return acc;
        }, {});

        let groupArray = Object.values(groupedData);
        const noRoleGroup = groupArray.find((g) => g.manufacturerName === "No Manufacturer");
        if (noRoleGroup) {
          groupArray = groupArray.filter((g) => g.manufacturerName !== "No Manufacturer");
          groupArray.push(noRoleGroup);
        }

        if (pageNum > 1) {
          setTimeout(() => {
            setProductData((prev) => [...prev, ...groupArray]);
          }, 500);
        } else {
          setProductData(groupArray);
          if (firstTimeApiCall) setHasData(groupArray.length > 0);
        }
      }
    } catch (error) {
      console.log("ManufactureProductSection getProductData-> Error:", error);
    } finally {
      setShowSearchLoader(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    dispatch(
      setShowReport({
        showReport: true,
        recordId: product?.productId ?? 0,
        name: Pages?.companiesProducts?.name,
        AppScreenId: Pages?.companiesProducts?.id
      })
    );
  };

  const onAddProductClick = () => setShowAddProductModal(true);
  const onItemClick = (item) => navigate(`/product/${item?.productId}`);
  const onProductClick = (currentTarget, prod) => {
    setProduct(prod);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prev) => {
      const next = prev + 1;
      callback(next);
      return next;
    });
  };

  const saveProduct = async (productId,manuId) => {
    if(manuId == id )
    {      
      return;
    }
    try {
      setIsLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ProductId: productId,
            CompanyId: id,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
      await Postrequestcall(SAVE_COMPANY_PRODUCT, obj, loginData?.accessToken);
      await getInitialData();
    } catch (error) {
      console.log("ManufactureProductSection saveProduct-> Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const canShowAddProductButton = allowPublicProductSubmission !== false;

  const NoInformation = () => (
    <Stack  sx={{ gap: 1, height: "100%" }}>
      {canShowAddProductButton && (
        <Button
          onClick={onAddProductClick}
          sx={{ alignSelf: "flex-end", color: color || "#083DB8" }}
          variant="outlined"
          size="small"
          startIcon={<BuildIcon />}>
          {TEXT_ADD_PRODUCT}
        </Button>
      )}
      <Box className="empty-data-card">
        <Emptydata
          icon={<InventoryIcon className="emptydata-icon" />}
          firstText={TEXT_NO_INFO_COMPANY || "No used products yet"}
          secondText={TEXT_NO_DATA_INFO_SUBTEXT}
        />
      </Box>
    </Stack>
  );

  const renderListing = () => (
    <Box>
      <Stack sx={{ gap: 1 }} >
        <Stack sx={{ alignItems: "center", justifyContent: "space-between", mb: 0.5 }} direction="row">
          <Stack direction="row" sx={{ gap: 1,  alignItems: "center"  }} >
            <InventoryIcon sx={{ color: "text.secondary", fontSize: 18 }} />
            <Typography variant="body2"  sx={{color: "text.secondary",  fontWeight: 500 }}>
              Products used by this manufacturer
            </Typography>
          </Stack>
          <Chip
            label={USED_PRODUCTS_TAB_LABEL}
            size="small"
            sx={{
              fontSize: "0.7rem",
              color: color || "#083DB8",
              borderColor: color || "#083DB8",
              bgcolor: `${color || "#083DB8"}14`
            }}
            variant="outlined"
          />
        </Stack>

        <SearchField
          placeholder={TEXT_SEARCH_COMPANY_PRODUCTS || "Search used products..."}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLoader(true);
            setSearchTerm(value);
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(() => {
              getProductData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLoader(true);
            getProductData(searchTerm, 1);
          }}
          size="small"
        />

        {canShowAddProductButton && (
          <Button
            variant="text"
            sx={{ alignSelf: "flex-end", color: color || "#083DB8" }}
            size="small"
            startIcon={<BuildIcon />}
            onClick={onAddProductClick}>
            {TEXT_ADD_PRODUCT}
          </Button>
        )}
      </Stack>

      <Stack spacing={1} sx={{ mt: 1 }}>
        {showSearchLoader ? (
          <Stack style={{ padding: "30px" }}>
            <Loader />
          </Stack>
        ) : productData?.length > 0 ? (
          <InfiniteScroll
            dataLength={productData?.length}
            next={() => increaseOffset((page) => getProductData(searchTerm, page))}
            hasMore={true}
            loader={
              !allDataLoaded ? null : (
                <h4 style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </h4>
              )
            }
            scrollableTarget={scrollId}>
            <List disablePadding>
              {productData.map((group) => (
                <Box key={group?.manufacturerId ?? group?.manufacturerName}>
                  <ListSubheader
                    sx={{
                      pl: 0.5,
                      cursor: group?.manufacturerId ? "pointer" : "default",
                      display: "flex",
                      alignItems: "center",
                      gap: 1
                    }}
                    onClick={() => {
                      group?.manufacturerId && navigate(`/manufacture/${group?.manufacturerId}`);
                    }}>
                    <Avatar
                      sx={{
                        width: 22,
                        height: 22,
                        fontSize: "0.65rem",
                        bgcolor: group?.manufacturerId ? (color || "#083DB8") : "grey.400"
                      }}>
                      {group?.manufacturerName?.[0] ?? "?"}
                    </Avatar>
                    <Typography sx={{ fontWeight: 700, color: group?.manufacturerId ? (color || "#083DB8") : "text.secondary",
                        textDecoration: group?.manufacturerId ? "underline" : "none" }} variant="caption">
                      {group?.manufacturerName}
                    </Typography>
                  </ListSubheader>

                  <Stack spacing={0.8} sx={{ mb: 1 }}>
                    {group?.items?.map((prod) => (
                      <Card
                        key={prod?.id ?? `${prod?.productName}-${Math.random()}`}
                        className="pagelist-content"
                        sx={{
                          transition: "all 0.18s",
                          "&:hover": {
                            boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
                            transform: "translateY(-1px)"
                          }
                        }}>
                        <ListItem
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              size="small"
                              onClick={(event) => onProductClick(event.currentTarget, prod)}>
                              <MoreIcon fontSize="small" />
                            </IconButton>
                          }>
                          <ListItemButton onClick={() => onItemClick(prod)}>
                            <ListItemText
                              primary={
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                  {prod?.productName}
                                </Typography>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </Box>
              ))}
            </List>
            <Menu
              anchorEl={moreMenuAnchorEl}
              open={Boolean(moreMenuAnchorEl)}
              onClose={() => setMoreMenuAnchorEl(null)}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}>
              <MenuItem onClick={handleOpenReportModal} style={{ color: BIRed }} dense>
                {BUTTON_REPORT}
              </MenuItem>
            </Menu>
          </InfiniteScroll>
        ) : (
          <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction="row" style={{ color: BIGrey, padding: "30px" }}>
            {TEXT_NO_RESULTS_FOUND}
          </Stack>
        )}
      </Stack>
    </Box>
  );

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader calc="calc(100vh - 240px)" /> : hasData ? renderListing() : <NoInformation />}
        {showAddProductModal && (
          <AddProductModal
            open={showAddProductModal}
            onClose={() => setShowAddProductModal(false)}
            from="manufacturer-company"
            mainId={id}
            saveProduct={saveProduct}
            manufactureDetails={manufactureDetails}
            title={TEXT_ADD_PRODUCT_TO_MANUFACTURER || "Add Product to Manufacturer"}
            lockManufacturerToCurrent={false}
            showCurrentManufacturerAction={true}
          />
        )}
      </Card>
    </Box>
  );
}

export default ManufactureProductSection;

